export default "__VITE_ASSET__2Tfjap$P__"